import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import React, { useState, useCallback, useContext } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Button } from 'ui-components/components/button';
import { FormattedMessage } from 'react-intl';
import { ProductDetailsContext } from '../../context';
import { removeProductVariant } from '../../../../store/products/products.api';
import { bulkLoadProductData } from '../../../../store/products/products.actions';
import AsModalWithContext from '../../../../components/as-modal/with-context';
import { RemoveVariantWarningModal } from './remove-variant-modal';
import { ProductDetailsService } from '../../../../services/product-details.service';

import { messages } from './messages';
import style from './style.module.less';

export const ProductVariant = ({ productId, sku, name, isActive, parentProductId, onAddedVariantRemoved }) => {
  const dispatch = useDispatch();
  const { productVariantIds, setProductVariantIds, openDifferentProductModal } = useContext(ProductDetailsContext);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const onOpenModal = useCallback(() => {
    setIsModalOpen(true);
  }, []);
  const onCloseModal = useCallback(() => {
    setIsModalOpen(false);
  }, [setIsModalOpen]);
  const onConfirm = useCallback(() => {
    const removeVariantPromise = removeProductVariant(productId);
    removeVariantPromise.promise
      .then(() => {
        setProductVariantIds(productVariantIds.filter((id) => id !== productId));
        dispatch(bulkLoadProductData([parentProductId, productId]));
        if (!productVariantIds.some((id) => id === productId)) {
          onAddedVariantRemoved(productId);
        }
        setIsModalOpen(false);
      })
      .catch(() => {
        ProductDetailsService.showGeneralErrorNotification();
      });
    return () => removeVariantPromise?.cancel();
  }, [parentProductId, productId, setIsModalOpen, productVariantIds, setProductVariantIds, dispatch, onAddedVariantRemoved]);
  return (
    <div className={style['variants-item']}>
      <div>
        <Button onClick={() => openDifferentProductModal(productId)} theme='link'>
          {sku}
        </Button>
      </div>
      <div>{name}</div>
      <div className={style.centered}>{isActive && <FontAwesomeIcon className={style['variant-active']} icon={faCheck} />}</div>
      <div>
        <Button onClick={onOpenModal} theme='link'>
          <FormattedMessage {...messages.productVariantsActionsLink} />
        </Button>
      </div>
      {isModalOpen && (
        <AsModalWithContext Context={ProductDetailsContext}>
          <RemoveVariantWarningModal onCloseModal={onCloseModal} onConfirm={onConfirm} sku={sku} />
        </AsModalWithContext>
      )}
    </div>
  );
};

ProductVariant.propTypes = {
  productId: PropTypes.string.isRequired,
  sku: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  parentProductId: PropTypes.string.isRequired,
  onAddedVariantRemoved: PropTypes.func.isRequired,
};
